import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Button from '@material-ui/core/Button';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import { StyledTableCell, StyledTableRow, StyledTableCellHead } from '../../atoms/table/tableStyles';
import { invokeGetService, invokePostService } from '../../../store/global/actions';
import Alert from '@material-ui/lab/Alert';
import { Grid } from '@material-ui/core';

const dayjs = require("dayjs");


export default function UndoRedoList({ action, response, setResponse }) {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [undoRedoData, setUndoRedoData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        fetchUndoRedoStack();
    }, [action]);

    const fetchUndoRedoStack = () => {
        setIsFetching(true);
        dispatch(invokeGetService('getUndoRedoList', [action])).then(res => {
            if (res?.status) {
                setUndoRedoData(res.data);
            }
            setIsFetching(false);
        });
    }

    const generateAction = (item) => {
        const mainEntity = item.entities.main;
        const action = `${mainEntity.action.charAt(0).toUpperCase() + mainEntity.action.slice(1)}d the ${mainEntity.type} ${mainEntity.entity.name ? mainEntity.entity.name : ""}`;
        return action;
    }

    const performUndoRedo = (ID) => {
        setLoading(true);
        dispatch(invokePostService(action, { ID, action })).then(res => {
            setLoading(false);
            fetchUndoRedoStack();
            setResponse(res);
        });
    }

    return (
        <>
            <Grid item xs={12}>
                {response && <Alert variant="filled" style={{ marginBottom: 10, marginTop: 10 }} severity={response.status === true ? "success" : "error"}>{response.message}</Alert>}
            </Grid>
            <TableContainer component={Paper} >
                <Table aria-label="undo redo table" >
                    <TableHead>
                        <TableRow>
                            <StyledTableCellHead align='center' > Action </StyledTableCellHead>
                            <StyledTableCellHead align='center'> Action Done By </StyledTableCellHead>
                            <StyledTableCellHead align='center' > Last Modified By </StyledTableCellHead>
                            <StyledTableCellHead align='center' > Last Modified Time </StyledTableCellHead>
                            <StyledTableCellHead align='center'> </StyledTableCellHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isFetching ?
                            <StyledTableRow>
                                <StyledTableCell align={'center'} colSpan={5} component="td" style={{ padding: 15 }}>
                                    Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                </StyledTableCell>
                            </StyledTableRow> :

                            undoRedoData.length < 1 ?
                                <StyledTableRow>
                                    <StyledTableCell align={'center'} colSpan={5} component="td" style={{ padding: 15 }}>
                                        {`No ${action} items available`}
                                    </StyledTableCell>
                                </StyledTableRow>
                                :

                                undoRedoData.map((item, index) => (
                                    <StyledTableRow>
                                        <StyledTableCell align={'center'} component="td" >
                                            {item.actionInfo}
                                        </StyledTableCell>

                                        <StyledTableCell align={'center'} component="td" >
                                            {item?.owner?.username}
                                        </StyledTableCell>

                                        <StyledTableCell align={'center'} component="td" >
                                            {item.users[0] ? item.users[0]?.username : ""}
                                        </StyledTableCell>

                                        <StyledTableCell align={'center'} component="td" >
                                            {dayjs(item.updatedAt).format("YYYY-MM-DD HH:mm:ss")}
                                        </StyledTableCell>

                                        <StyledTableCell align={'center'} component="td" >
                                            {index === 0 && <Button disabled={loading} style={{textTransform: "none", padding: "6px 24px"}} variant="contained" onClick={() => performUndoRedo(item._id)}>
                                                {action === "undo" ? "Undo" : "Redo"}
                                            </Button>}
                                        </StyledTableCell>

                                    </StyledTableRow>
                                ))

                        }
                    </TableBody>
                </Table>
            </TableContainer>

        </>
    )
}
